// todo: check if cant be substituted by scroll-behavior: smooth
// https://developer.mozilla.org/en-US/docs/Web/CSS/scroll-behavior
export const SmoothScroll = {
	selectors: {
		smoothScrollSelector: Array.prototype.slice.call(document.querySelectorAll('.js-smooth-scroll'))
	},

	init: function() {
		let self = this;

		if (self.selectors.smoothScrollSelector) {
			self.selectors.smoothScrollSelector.forEach(x => {
				x.addEventListener('click', function(e) {
					e.preventDefault();

					let dataID = this.dataset.scroll;
					let target = document.querySelector(`[data-scroll-target=${dataID}]`).getBoundingClientRect().top;

					window.scrollTo({
						top: target + scrollY,
						behavior: 'smooth',
					});
				});
			});
		}
	}
}

SmoothScroll.init();
